export default "__VITE_ASSET__CnneQ2OB__"